import styled from 'styled-components';
import { layout, remCalc } from '@prisjakt/ui-base';
import { Hideable } from '@regular_ui/lib/components/hideable';
import { Speed, Delay } from '@regular_ui/lib/definitions';
import { slideHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';
import { MenuItem } from '../../../../../sidebar/views/user/styles';

export const Categories = styled(Hideable).attrs({
  variant: slideHideableVariant,
  speed: Speed.Fast,
  delayIn: Delay.Short,
})`
  flex-direction: column;
  padding-bottom: ${layout.spacing.xSmall};
  width: 100%;
`;

export const CategoryListHeading = styled.h2`
  font-size: ${remCalc(10)};
  font-weight: normal;
  letter-spacing: 1.5px;
  margin: 0;
  padding: ${layout.spacing.xSmall};
  text-transform: uppercase;
`;

export const CategoryLogo = styled.img`
  height: 40px;
  width: 40px;
`;

export const ViewAllMenuItem = styled(MenuItem)`
  color: ${props =>
    props.sidebar ? props.theme.text.callToAction : props.theme.text.primary};
`;

export const StylesMenuItem = styled(MenuItem)``;
